<template>
  <SpForm ref="orderFormRef" @submit="submit">

    <div class="tct-order">
      <div class="flex-jc-bt mg-20">
        <div class="flex-1 left" style="">
          <SpCard class="card cus-card" custom-class="sp-color-bg-4">
            <div class="pd-10">
              <p class="font18 sp-color-1 text-left" style="margin: 0 0 10px 0; padding: 0">Cargo Intention</p>
              <SpTagGroup v-model="selectedTag">
                <SpTag v-for="(cargo, index) in selectedCargoes" :key="index"
                       :line-height="36"
                       class="cus-spTag"
                       :have-close="true"
                       :index="index"
                       :label="index"
                       @delCargo="delCargo">
                  <span class="font-normal font12">{{ cargo.name }}</span>
                  <i v-if="selectedCargoes.length > 1" class="font12 icon-close iconfont mg-l-10 pointer sp-color-18" style="position:absolute;top:-4px; "
                     @click.capture.stop="delCargo(index)" />
                </SpTag>
                <SpTag label="add" :disabled="!currentCargo?.id" :line-height="36"
                       @click.stop="addNewCargo(selectedTag)">
                  <span style="font-size: 14px" class="icon-jiahao iconfont sp-color-18" />
                </SpTag>
              </SpTagGroup>
              <el-table class="table-td-empty" :header-cell-style="{background:'#D6E9F0', textAlign: 'center'}" border
                        :cell-style="{textAlign: 'center'}"
                        style="width: 100%"
                        :cell-class-name="handleCellClassName" align="center"
                        :data="new Array(1).fill({...currentCargo})" row-key="id">
                <el-table-column fixed prop="name" label="Cargo Name for Trade" width="260">
                  <template #default="scope">
                    <div style="background-color: rgba(254, 212, 126, .2)">
                      <el-select class="cus-el-select-table"
                                 :filterable="true"
                                 :input-style="{fontSize: '12px'}"
                                 @change="selectCargo"
                                 v-model="currentCargo.id" placeholder="">
                        <el-option v-for="cargo in cargoes"
                                   :disabled="selectedCargoes.map(s => s.id).includes(cargo.id)"
                                   :label="cargo.name" :value="cargo.id"
                                   :key="cargo.id"/>
                      </el-select>
<!--                      :disabled="selectedCargoes.map(s => s.id).includes(cargo.id)"-->
<!--                      <SpSelect v-if="cargoes?.length > 0" v-model="currentCargo.id" class="cargo-select font-12-select"-->
<!--                                :class="{'show-error-class': needShowErr && (!currentCargo.id || currentCargo.id === 'new')}"-->
<!--                                :text-style="{fontSize: '12px', textAlign: 'center', textIndent: 0, paddingLeft: '8px'}"-->
<!--                                height="49"-->
<!--                                :show-clear="false"-->
<!--                                type="warn3"-->
<!--                                strategy="fixed"-->
<!--                                @after-select="selectCargo">-->
<!--                        <SpSelectOption-->
<!--                            v-for="cargo in cargoes"-->
<!--                            :key="cargo.id"-->
<!--                            :disabled="selectedCargoes.map(s => s.id).includes(cargo.id)"-->
<!--                            :label="cargo.name" :value="cargo.id" />-->
<!--                      </SpSelect>-->
                    </div>
                    <div class="table-tag" @click="clearCurrentCargo">
                      <div class="tag-label">Clear</div>
                    </div>

                  </template>
                </el-table-column>
                <el-table-column prop="imsbcCode" label="IMSBC CODE" min-width="130" />
                <el-table-column prop="tbUnit" label="TB Unit" />
                <el-table-column prop="packingMethod" label="Packing Method" min-width="120" />
                <el-table-column prop="packingDimensionDesc" label="Packing & Dimension" min-width="200">
                  <template #default="scope">
                    <div class="ellipsis-3">
                      {{ scope.row.packingDimensionDesc ? scope.row.packingDimensionDesc : '-' }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="obUnit" label="OB Unit" />
                <el-table-column prop="sf" label="SF" min-width="120">
                  <template #default="scope">
                    <div v-if="scope.row.extInput?.sf?.dwt">
                      DWT
                    </div>
                    <div v-else-if="scope.row.extInput?.sf?.aboutCbm" class="mg-t-20">
                      <p>
                        {{ scope.row.extInput?.sf?.aboutCbm }}
                      </p>
                    </div>
                    <div v-else-if="scope.row.extInput?.sf?.aboutCbft" class="mg-t-20">
                      <p>
                        {{ scope.row.extInput?.sf?.aboutCbft }}
                      </p>
                    </div>
                    <div v-else-if="scope.row.extInput?.sf?.cbftMin && scope.row.extInput?.sf?.cbftMax">
                      {{ scope.row.extInput?.sf.cbftMin }} - {{ scope.row.extInput.sf?.cbftMax }}
                    </div>
                    <div v-else>
                      {{ scope.row.sfMin }} - {{ scope.row.sfMax }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="sf" label="WF" min-width="100">
                  <template #default="scope">
                    <div>
                      {{ scope.row.wfMin }} - {{ scope.row.wfMax }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="More" width="60">
                  <template #default="scope">
                    <span v-if="scope.row?.id" :ref="'more'+scope.$index" class="icon-gengduo iconfont pointer" style="font-size: 20px"
                          @click="showMore = true, checkItem.id = scope.row.id " />
                  </template>
                </el-table-column>
              </el-table>
              <OrderInfo v-model="cargoOrders" :show-err="needShowErr" :quantity-unit="quantityUnit" :default-types="defaultTypes" :default-options="defaultOptions" />
            </div>
          </SpCard>
        </div>
        <div class="pd-l-10 right">
          <div class="flex-jc-end">
            <SpButton class="mg-r-10" :disabled="submitDisabled" type="primary3" circle-radius="4" width="195" :height="70" @click="submitReview">
              <span class="font-bold font14 sp-color-11">Submit after review</span>
            </SpButton>
            <SpButton type="primary" :disabled="submitDisabled" circle-radius="4" width="195" :height="70" html-type="submit">
              <span class="font-bold font14">Submit</span>
            </SpButton>
          </div>
          <div class="sp-color-bg-4" style="padding: 20px 15px 15px 15px; margin-top: 32px; height: 400px">
            <MoreRequired :default-requirements="defaultRequirements" @saveMoreRequired="saveMoreRequired" />
            <!--          laycan -->
<!--            27px-->
            <div class="items" style="margin-top: 20px">
              <div class="flex-al-center flex-jc-bt" style="margin-top: 0">
                <span v-required class="font12 fs-bold italic text-center" style="position: relative;z-index: 9">{{ $l('Laycan') }}:</span>
              </div>
              <div style="width: 100%; overflow:hidden;position:relative; top: -3px;z-index: 8;">
                <OpenDatePicker v-model="cargoOrders" style="width: 100% ">
                  <div class="font18 open-date-select sp-color-bg-6 text-left" :class="{'show-error-div': (!cargoOrders.earliestLaycan || !cargoOrders.latestLaycan) && needShowErr}" style="line-height: 38px;">
                    <span v-if="cargoOrders.earliestLaycan && cargoOrders.latestLaycan">
                      <span class="font12" v-html="formatDateSection(cargoOrders.earliestLaycan, cargoOrders.latestLaycan, ' - ')" />
                    </span>
                    <!--                {{ getDateToFormatEn(cargoOrders.earliestLaycan, false) }} - {{ getDateToFormatEn(cargoOrders.latestLaycan, false) }} -->
                  </div>
                </OpenDatePicker>
              </div>

              <!--            <div class="font14 italic laycan-origin text-center" style="position:relative; top: -5px; padding-top: 12px"> -->
              <!--              {{ cargoOrders.laycanLabels }} -->
              <!--            </div> -->
            </div>
<!--            43px-->
            <div class="items" style="margin-top: 10px">
              <div class="flex-al-center flex-jc-bt" style="margin-top: 0">
                <span v-required class="font12 fs-bold italic text-center" style="position: relative;z-index: 10">{{ $l('ACCTCharterers') }}:</span>
              </div>
              <SpSelect v-model="cargoOrders.acctId" class="cus-select-12 flex-1" style="position:relative; top: -3px;z-index: 9;"
                        type="warn" :text-area="true" height="50" required
                        :back-selected-option="true" :back-option="true"
                        name="cargoOrders.acctId"
                        @change="(value,labels, optionSeleted)=> {cargoOrders.chartererAcctCorp = optionSeleted}"
              >
                <SpSelectOption
                    v-for="acct in acctCharterers"
                    :key="acct.value"
                    :label="acct.label" :value="acct.value" />
              </SpSelect>
              <!--            @change="(value,labels, optionSeleted)=> {cargoOrders.chartererAcctCorp = optionSeleted}" -->
            </div>
            <div class="items" style="margin-top: 10px">
              <div class="flex-al-center flex-jc-bt" style="margin-top: 0">
                <span v-required class="font12 fs-bold italic text-center" style="position: relative;z-index: 3">{{ $l('ACCT津洋业务员人工录入') }}:</span>
              </div>
              <SpInput v-model="cargoOrders.extension.charterer" class="flex-1" style="position:relative; top: -3px;z-index: 1; background: #ed6c00;"
                       type="warn" height="40" width="100%" :text-style="{color: '#FFFFFF' }"
                       :validate-reg="/^(?=.*[a-zA-Z])[\w\-().,'& ]{3,64}$/"
                       :error-msg-fun="()=>'The ACCT name should be consisted of letters, numbers, punctuation, and it must contain some letters, its total length should between 3 ~ 64.'"
                       name="cargoOrders.extension.charterer"
              />
              <!--            @change="(value,labels, optionSeleted)=> {cargoOrders.chartererAcctCorp = optionSeleted}" -->
            </div>
          </div>
        </div>
      </div>
      <div>
        <CargoOrderEdit2 v-model="cargoOrders" class="tct-order-more" :ftcontent="fullTermsContent" />
      </div>
    </div>
  </SpForm>

  <SpDrawer v-model="showMore" dragable :offset-top="20" width="0.98" height="0.8">
    <CargoMore class="font12" :cargo-id="checkItem.id" :show-right-claim="false" />
  </SpDrawer>
  <SubmitReview :show="showReview" :cargo-orders="cargoOrders" :quantity-unit="quantityUnit"
                @to-submit="reviewEndToSubmit" @close="showReview = false; needReview = false" />
  <el-dialog
      v-model="dialogVisible"
      width="30%"
      :before-close="handleClose"
  >
    <span>What to do with the old Cargo Order?</span>
    <template #footer>
      <div class="dialog-footer" style="display: block">
        <div class="flex flex-al-end">
          <div class="flex-1">
            <SpButton type="cancleLight" height="42px" width="120px" @click="submitComfirm('del')">Delete</SpButton>
          </div>
          <div style="width: 120px">
            <SpButton type="confirm" height="42px" width="120px" @click="submitComfirm(keep)">
              Keep
            </SpButton>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { isObject } from '@/utils/index'
import _compact from 'lodash/compact'
import SpButton from '@/components/common/SpButton'
import SpCard from '@/components/common/SpCard.vue'
import SpTagGroup from '@/components/common/SpTagGroup.vue'
import SpTag from '@/components/common/SpTag.vue'
import { onMounted, reactive, ref, watch } from 'vue'
import { computed, nextTick } from '@vue/runtime-core'

import { getDateToFormatEn, formatDateSection } from '@/utils/convert'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import SpMessage from '@/components/common/SpMessage'
import _replace from 'lodash/replace'
import { getCargoDetailApi, getCargoOwnedApi } from '../../../../request/APIs/co'
import { useRoute, useRouter } from 'vue-router'
import SpDrawer from '@/components/common/SpDrawer'
import CargoMore from '@/components/cargoOwner/cargo/cargoCollection/CargoMore'
import CargoOrderEdit2 from './CommonInfo'
import OrderInfo from './OrderInfo'
import OpenDatePicker from '../../cargoOrders/cargoOrderEdit/OpenDatePicker'
import { getEnterpriseOptionsCorpApi } from '../../../../request/APIs/company'
import MoreRequired from './MoreRequired'
import SubmitReview from './SubmitReview'
import _cloneDeep from 'lodash/cloneDeep'
import SpForm from '@/components/common/SpForm'
import _isEqual from 'lodash/isEqual'
import { cargoOrderTctAddApi, cargoOrderTctInformationdAllApi } from '../../../../request/APIs/boAndOp'
import { closeGlobalLoading, showGlobalLoading } from '@/components/common/SpLoading'
import _uniq from 'lodash/uniq'
import _uniqBy from 'lodash/uniqBy'
import SpInput from '../../../common/SpInput'
import { useStore } from 'vuex'
export default {
  name: 'Index',
  components: {
    SpInput,
    SubmitReview,
    MoreRequired,
    OpenDatePicker,
    OrderInfo,
    SpDrawer,
    SpSelectOption,
    SpSelect,
    SpButton,
    SpCard,
    SpTagGroup,
    SpTag,
    CargoMore,
    CargoOrderEdit2,
    SpForm
  },

  setup (props, ctx) {
    const showReview = ref(false) // review弹窗
    const needReview = ref(false)
    const dialogVisible = ref(false)
    const submitParmas = ref(null)
    const submitFormData = ref(null)

    const needShowErr = ref(false)
    const orderFormRef = ref(null) // 表单

    const orgrinCargoOrders = ref(null)
    const defaultTypes = reactive({
      dwt: ''
    })
    const store = useStore()
    console.log(store)
    const userInfo = store.state?.user?.user
    const fullTermsContent = ref('')
    const cargoOrders = reactive({
      earliestLaycan: null,
      latestLaycan: null,
      delyTag: '1SP',
      redelTag: '1SP',
      dwtRequirement: {
        vesselTypes: [],
        kiloMin: null,
        kiloMax: null,
        dwtMin: null,
        dwtMax: null
      },
      selectedCargoes: [],
      periodUnit: 'Days',
      term: {
        fullTermId: null, // 完整租船条款ID
        paragraphId: null, //	惯用段落ID
        descriptionId: null, // 货物描述ID
        proformaId: null,	// 合同范本ID
        content: null	// 编辑后的完整条款内容
      },
      delyPorts: {
        ports: [],
        regions: [],
        zones: []
      },
      redelPorts: {
        ports: [],
        regions: [],
        zones: []
      },
      viaPortLoad: {
        ports: [],
        regions: [],
        zones: []
      },
      viaPortDischarge: {
        ports: [],
        regions: [],
        zones: []
      },
      tradeArea: {
        ports: [],
        regions: [],
        zones: [270]
      },
      adcom: 3.75,
      plusBbCc: 'EUR',
      hireRateCc: 'EUR',
      acctId: userInfo.affiliation?.subCorpId || userInfo.affiliation?.masterCorpId,
      extension: {
        charterer: null
      }
    })
    const defaultRequirements = ref(null)
    const defaultOptions = reactive({
      ports: [],
      regions: [],
      zones: []
    })
    const cargoes = ref([])
    onMounted(() => {
      getCargoOwnedApi('all').then(res => {
        cargoes.value = res.data.filter(item => item.status > 0)
      })
    })
    const selectedTag = ref('new')
    const selectedCargoes = ref([])
    const currentCargo = ref({})
    const route = useRoute()
    const router = useRouter()
    if (route.query.orderId) {
      cargoOrderTctInformationdAllApi(route.query.orderId).then(res => {
        fullTermsContent.value = res.data.term.content
        const cargos = res.data.items.map(c => {
          return {
            ...c,
            id: c.cargoId
          }
        })
        currentCargo.value = cargos[0]
        selectedTag.value = 0
        selectedCargoes.value = cargos
        const orderInfo = res.data

        const delyPorts = {
          ports: [],
          regions: [],
          zones: []
        }
        let portOptions = []
        let countryOptions = []
        let zoneOptions = []
        if (isObject(orderInfo.delyPorts.ports)) {
          delyPorts.ports = Object.keys(orderInfo.delyPorts.ports).map(item => parseInt(_replace(item, 'p-', '')))
          Object.keys(orderInfo.delyPorts.ports).forEach(id => {
            const portAndCountry = orderInfo.delyPorts.ports[id].split('@@')
            const countryInfo = (portAndCountry[1].replace(']]', '')).split('[[')
            portOptions.push({
              value: parseInt(_replace(id, 'p-', '')),
              label: portAndCountry[0],
              countryId: countryInfo[1]
            })
          })
          portOptions = _uniqBy(portOptions, 'value')
        } else if (isObject(orderInfo.delyPorts.regions)) {
          delyPorts.regions = Object.keys(orderInfo.delyPorts.regions).map(item => parseInt(_replace(item, 'r-', '')))
          Object.keys(orderInfo.delyPorts.regions).forEach(id => {
            countryOptions.push({
              value: parseInt(_replace(id, 'r-', '')),
              label: orderInfo.delyPorts.regions[id]
            })
          })
          countryOptions = _uniqBy(countryOptions, 'value')
        } else {
          delyPorts.zones = Object.keys(orderInfo.delyPorts.zones).map(item => parseInt(_replace(item, 'z-', '')))
          Object.keys(orderInfo.delyPorts.zones).forEach(id => {
            zoneOptions.push({
              value: parseInt(_replace(id, 'z-', '')),
              label: orderInfo.delyPorts.zones[id]
            })
          })
          zoneOptions = _uniqBy(zoneOptions, 'value')
          // Object.keys(sub.loadingPorts.zones)
        }

        if (isObject(orderInfo.delyPorts.alternates)) {
          delyPorts.alternates = Object.keys(orderInfo.delyPorts.alternates).map(item => parseInt(_replace(item, 'a-', '')))

          Object.keys(orderInfo.delyPorts.alternates).forEach(id => {
            const portAndCountry = orderInfo.delyPorts.alternates[id].split('@@')
            const countryInfo = (portAndCountry[1].replace(']]', '')).split('[[')

            portOptions.push({
              value: parseInt(_replace(id, 'a-', '')),
              label: portAndCountry[0],
              countryId: countryInfo[1]
            })
          })
          portOptions = _uniqBy(portOptions, 'value')
        }

        const redelPorts = {
          ports: [],
          regions: [],
          zones: []
        }
        if (isObject(orderInfo.redelPorts.ports)) {
          redelPorts.ports = Object.keys(orderInfo.redelPorts.ports).map(item => parseInt(_replace(item, 'p-', '')))
          Object.keys(orderInfo.redelPorts.ports).forEach(id => {
            const portAndCountry = orderInfo.redelPorts.ports[id].split('@@')
            const countryInfo = (portAndCountry[1].replace(']]', '')).split('[[')
            portOptions.push({
              value: parseInt(_replace(id, 'p-', '')),
              label: portAndCountry[0],
              countryId: countryInfo[1]
            })
          })
          portOptions = _uniqBy(portOptions, 'value')
        } else if (isObject(orderInfo.redelPorts.regions)) {
          redelPorts.regions = Object.keys(orderInfo.redelPorts.regions).map(item => parseInt(_replace(item, 'r-', '')))
          Object.keys(orderInfo.redelPorts.regions).forEach(id => {
            countryOptions.push({
              value: parseInt(_replace(id, 'r-', '')),
              label: orderInfo.redelPorts.regions[id]
            })
          })
          countryOptions = _uniqBy(countryOptions, 'value')
        } else {
          redelPorts.zones = Object.keys(orderInfo.redelPorts.zones).map(item => parseInt(_replace(item, 'z-', '')))
          Object.keys(orderInfo.redelPorts.zones).forEach(id => {
            zoneOptions.push({
              value: parseInt(_replace(id, 'z-', '')),
              label: orderInfo.redelPorts.zones[id]
            })
          })
          zoneOptions = _uniqBy(zoneOptions, 'value')
          // Object.keys(sub.loadingPorts.zones)
        }

        const viaPortLoad = {
          ports: [],
          alternates: []
        }
        if (isObject(orderInfo.viaPortLoad.ports)) {
          viaPortLoad.ports = Object.keys(orderInfo.viaPortLoad.ports).map(item => parseInt(_replace(item, 'p-', '')))
          Object.keys(orderInfo.viaPortLoad.ports).forEach(id => {
            const portAndCountry = orderInfo.viaPortLoad.ports[id].split('@@')
            const countryInfo = (portAndCountry[1].replace(']]', '')).split('[[')
            portOptions.push({
              value: parseInt(_replace(id, 'p-', '')),
              label: portAndCountry[0],
              countryId: countryInfo[1]
            })
          })
          portOptions = _uniqBy(portOptions, 'value')
        }
        if (isObject(orderInfo.viaPortLoad.alternates)) {
          viaPortLoad.alternates = Object.keys(orderInfo.viaPortLoad.alternates).map(item => parseInt(_replace(item, 'a-', '')))

          Object.keys(orderInfo.viaPortLoad.alternates).forEach(id => {
            const portAndCountry = orderInfo.viaPortLoad.alternates[id].split('@@')
            const countryInfo = (portAndCountry[1].replace(']]', '')).split('[[')

            portOptions.push({
              value: parseInt(_replace(id, 'a-', '')),
              label: portAndCountry[0],
              countryId: countryInfo[1]
            })
          })
          portOptions = _uniqBy(portOptions, 'value')
        }

        const tradeArea = {
          regions: [],
          zones: []
        }

        if (isObject(orderInfo.tradeArea.regions)) {
          tradeArea.regions = Object.keys(orderInfo.tradeArea.regions).map(item => parseInt(_replace(item, 'r-', '')))
          Object.keys(orderInfo.tradeArea.regions).forEach(id => {
            countryOptions.push({
              value: parseInt(_replace(id, 'r-', '')),
              label: orderInfo.tradeArea.regions[id]
            })
          })
          countryOptions = _uniqBy(countryOptions, 'value')
        }
        if (isObject(orderInfo.tradeArea.zones)) {
          tradeArea.zones = Object.keys(orderInfo.tradeArea.zones).map(item => parseInt(_replace(item, 'z-', '')))
          Object.keys(orderInfo.tradeArea.zones).forEach(id => {
            zoneOptions.push({
              value: parseInt(_replace(id, 'z-', '')),
              label: orderInfo.tradeArea.zones[id]
            })
          })
          zoneOptions = _uniqBy(zoneOptions, 'value')
          // Object.keys(sub.loadingPorts.zones)
        }

        const viaPortDischarge = {
          ports: [],
          alternates: []
        }
        if (isObject(orderInfo.viaPortDischarge.ports)) {
          viaPortDischarge.ports = Object.keys(orderInfo.viaPortDischarge.ports).map(item => parseInt(_replace(item, 'p-', '')))
          Object.keys(orderInfo.viaPortDischarge.ports).forEach(id => {
            const portAndCountry = orderInfo.viaPortDischarge.ports[id].split('@@')
            const countryInfo = (portAndCountry[1].replace(']]', '')).split('[[')
            portOptions.push({
              value: parseInt(_replace(id, 'p-', '')),
              label: portAndCountry[0],
              countryId: countryInfo[1]
            })
          })
          portOptions = _uniqBy(portOptions, 'value')
        }
        if (isObject(orderInfo.viaPortDischarge.alternates)) {
          viaPortDischarge.alternates = Object.keys(orderInfo.viaPortDischarge.alternates).map(item => parseInt(_replace(item, 'a-', '')))

          Object.keys(orderInfo.viaPortDischarge.alternates).forEach(id => {
            const portAndCountry = orderInfo.viaPortDischarge.alternates[id].split('@@')
            const countryInfo = (portAndCountry[1].replace(']]', '')).split('[[')

            portOptions.push({
              value: parseInt(_replace(id, 'a-', '')),
              label: portAndCountry[0],
              countryId: countryInfo[1]
            })
          })
          portOptions = _uniqBy(portOptions, 'value')
        }

        defaultOptions.ports = portOptions
        defaultOptions.regions = countryOptions
        defaultOptions.zones = zoneOptions

        if (orderInfo.dwtRequirement?.kiloMin || orderInfo.dwtRequirement?.kiloMax) {
          defaultTypes.dwt = 'kMt'
        } else if (orderInfo.dwtRequirement?.dwtMin || orderInfo.dwtRequirement?.dwtMax) {
          defaultTypes.dwt = 'mt'
        } else {
          defaultTypes.dwt = 'select'
        }

        if (orderInfo.periodAbout) {
          defaultTypes.duration = 'about'
        } else if (orderInfo.periodFrom || orderInfo.periodTo) {
          defaultTypes.duration = 'range'
        }

        if (orderInfo?.hireRateSplit && orderInfo?.hireRateSplitTime && orderInfo?.hireRateDiot) {
          defaultTypes.hireRate = 'pdDio'
        } else if (orderInfo?.hireRateDiot) {
          defaultTypes.hireRate = 'dio'
        }
        defaultRequirements.value = {
          swlRequired: orderInfo.requirements.swlRequired ? parseInt(orderInfo.requirements.swlRequired) : null,
          ageMax: orderInfo.requirements.ageMax ? parseInt(orderInfo.requirements.ageMax) : null,
          ageMin: orderInfo.requirements.ageMin ? parseInt(orderInfo.requirements.ageMin) : null,
          deckTypeId: orderInfo.requirements?.deckTypeId ? orderInfo.requirements?.deckTypeId : null,
          holdTypeId: orderInfo.requirements?.holdTypeId ? orderInfo.requirements?.holdTypeId : null,
          cargoTypeId: orderInfo.requirements?.cargoTypeId ? orderInfo.requirements?.cargoTypeId : null,
          structureTypeId: orderInfo.requirements?.structureTypeId ? orderInfo.requirements?.structureTypeId : null,
          deckTypeLabels: orderInfo.requirementsDetail?.deckType?.name,
          shipHoldLabels: orderInfo.requirementsDetail?.shipHold?.name,
          cargoTypeLabels: orderInfo.requirementsDetail?.cargoType?.name,
          structureTypeLabels: orderInfo.requirementsDetail?.structureType?.name
        }
        const order = {
          items: orderInfo.items.map(item => parseInt(item.cargoId)),
          delyTag: orderInfo.delyTag,
          redelTag: orderInfo.redelTag,
          delyPorts,
          redelPorts,
          viaPortDischarge,
          tradeArea,
          viaPortLoad,
          dwtRequirement: orderInfo.dwtRequirement,

          periodAbout: orderInfo.periodAbout ? orderInfo.periodAbout : null,
          periodFrom: orderInfo.periodFrom ? orderInfo.periodFrom : null,
          periodTo: orderInfo.periodTo ? orderInfo.periodTo : null,
          periodUnit: orderInfo.periodUnit,
          llMin: orderInfo.llMin ? orderInfo.llMin : null,
          llMax: orderInfo.llMax ? orderInfo.llMax : null,

          hireRateDiot: orderInfo.hireRateDiot ? orderInfo.hireRateDiot : null,
          hireRateSplit: orderInfo.hireRateSplit ? orderInfo.hireRateSplit : null,
          hireRateSplitTime: orderInfo.hireRateSplitTime ? orderInfo.hireRateSplitTime : null,

          plusBbLumpsum: orderInfo.plusBbLumpsum ? orderInfo.plusBbLumpsum : null,
          plusBbCc: orderInfo.plusBbCc ? orderInfo.plusBbCc : 'EUR',
          plusBbLumpsumCustom: orderInfo.plusBbLumpsumCustom ? orderInfo.plusBbLumpsumCustom : null,

          hireRateCc: orderInfo.hireRateCc ? orderInfo.hireRateCc : 'EUR',
          hireRateDiotCustom: orderInfo.hireRateDiotCustom ? orderInfo.hireRateDiotCustom : null,
          hireRateSplitCustom: orderInfo.hireRateSplitCustom ? orderInfo.hireRateSplitCustom : null,
          hireRateSplitTimeCustom: orderInfo.hireRateSplitTimeCustom ? orderInfo.hireRateSplitTimeCustom : null,
          adcom: parseFloat(orderInfo.adcom) > 0 ? parseFloat(orderInfo.adcom) : 'Nil',

          quantityMin: orderInfo.quantityMin ? orderInfo.quantityMin : null,
          quantityMax: orderInfo.quantityMax ? orderInfo.quantityMax : null,
          capacityMin: orderInfo.capacityMin ? orderInfo.capacityMin : null,
          capacityMax: orderInfo.capacityMax ? orderInfo.capacityMax : null,
          weightMin: orderInfo.weightMin ? orderInfo.weightMin : null,
          weightMax: orderInfo.weightMax ? orderInfo.weightMax : null,

          earliestLaycan: orderInfo.earliestLaycan,
          latestLaycan: orderInfo.latestLaycan,
          acctId: orderInfo.acctId,
          extension: {
            charterer: orderInfo?.extension?.charterer
          },
          requirements: defaultRequirements.value,
          term: orderInfo.term

        }

        Object.assign(cargoOrders, _cloneDeep(order))
        orgrinCargoOrders.value = _cloneDeep(order)
      })
    } else if (route.query.id) {
      getCargoDetailApi(route.query.id).then(res => {
        if (res.code === 1) {
          currentCargo.value = res.data
          selectedTag.value = 0
          selectedCargoes.value = [{
            ...res.data
          }]
        }
      })
    } else {
      currentCargo.value = {
        name: ''
      }
      selectedTag.value = 0
      selectedCargoes.value = [{
        id: 'new',
        name: 'new'
      }]
    }

    const showMore = ref(false)
    const checkItem = ref({})
    const submitDisabled = computed(() => { // 是否符合条件 可以提交
      return false
    })

    const submit = (formData, form) => {
      needShowErr.value = false
      if (!formData.validate) {
        SpMessage.error('There is some error in the form list!')
        needShowErr.value = true
        return
      }
      let cargoIds = selectedCargoes.value.map(item => item?.id)
      cargoIds = _compact(cargoIds)
      if (cargoIds?.length < 0 || cargoIds.includes('new') || cargoIds.length !== selectedCargoes.value.length) {
        needShowErr.value = true
        SpMessage.error('Cargo Name for Trade is required！')
        return
      }

      const delyPorts = [...cargoOrders?.delyPorts?.ports || [], ...cargoOrders?.delyPorts?.regions || [], ...cargoOrders?.delyPorts?.zones || []]
      const redelPorts = [...cargoOrders?.redelPorts.ports || [], ...cargoOrders?.redelPorts?.regions || [], ...cargoOrders?.redelPorts?.zones || []]

      if (delyPorts.length < 1 || redelPorts.length < 1) {
        needShowErr.value = true
        SpMessage.error('Delivery Port And Redelivery Port is required！')
        return
      }

      if ((cargoOrders?.dwtRequirement.vesselTypes === undefined || cargoOrders?.dwtRequirement.vesselTypes?.length === undefined || cargoOrders?.dwtRequirement.vesselTypes?.length < 1) && (!cargoOrders?.dwtRequirement.kiloMin || !cargoOrders.dwtRequirement.kiloMax) && (!cargoOrders?.dwtRequirement.dwtMin || !cargoOrders.dwtRequirement.dwtMax)) {
        needShowErr.value = true
        SpMessage.error('DWT Required is required！')
        return
      }

      const tradePorts = [...cargoOrders?.tradeArea?.regions || [], ...cargoOrders?.tradeArea?.zones || []]
      if (tradePorts.length < 1) {
        needShowErr.value = true
        SpMessage.error('Trade Area is required！')
        return
      }

      if (!cargoOrders?.earliestLaycan || !cargoOrders?.latestLaycan) {
        needShowErr.value = true
        SpMessage.error('Laycan is required！')
        return
      }
      if (needShowErr?.value) {
        SpMessage.error('There is some error in the form list!')
        return
      }

      const parmas = cargoOrders

      parmas.items = selectedCargoes.value.map(cargo => cargo.id)
      cargoOrders.items = parmas.items

      if (route.query.orderId) {
        const co = _cloneDeep(cargoOrders)
        const or = _cloneDeep(orgrinCargoOrders.value)
        delete co.chartererAcctCorp
        delete co.commonInfo
        delete co.delyPortsSelected
        delete co.delyPortsSelectedOption
        delete co.laycanLabels
        delete co.chartererAcctCorp
        delete co.redelPortsSelected
        delete co.redelPortsSelectedOption
        delete co.tradeRegionLabels
        delete co.tradeZoneLabels
        delete co.selectedCargoes
        delete co.viaPortDischargeLabels
        delete co.viaPortLoadLabels

        if (_isEqual(or, co)) {
          SpMessage.error('Please Edit')
          return
        }
      }
      // const parmas = cargoOrders
      // parmas.items = selectedCargoes.value.map(cargo => cargo.id)
      // parmas.adcom = parmas.adcom === 'Nil' ? 0 : parmas.adcom
      // parmas.term = cargoOrders.term

      if (needReview.value) {
        showReview.value = true
        submitParmas.value = _cloneDeep(parmas)
        submitFormData.value = _cloneDeep(formData)
        return
      }
      if (route.query.orderId) {
        dialogVisible.value = true
        submitParmas.value = _cloneDeep(parmas)
        submitFormData.value = _cloneDeep(formData)
        return
      }

      cargoOrderAdd(parmas, formData)
    }

    const submitReview = () => { // 提交之前先预览
      orderFormRef.value.beforeSubmit()
      needReview.value = true
      cargoOrders.selectedCargoes = selectedCargoes.value
      // showReview.value = true
    }
    watch(() => selectedTag.value, (n, o) => {
      currentCargo.value = selectedCargoes.value[selectedTag.value]
    })
    const delCargo = (index) => {
      selectedCargoes.value.splice(index, 1)
      if (selectedTag.value > index - 1) {
        selectedTag.value = selectedTag.value - 1
      }
      if (selectedTag.value === -1) {
        selectedTag.value = 0
      }
      currentCargo.value = selectedCargoes.value[selectedTag.value]
      // selectedTag.value = selectedCargoes.value
    }
    const addNewCargo = (nowTag) => {
      const ids = selectedCargoes.value.map(item => item.id)
      if (ids.includes('new')) {
        SpMessage.error('Please select Cargo Name for Trade')
        return
      }
      selectedCargoes.value.push({
        name: 'new',
        id: ''
      })
      selectedTag.value = selectedCargoes.value.length - 1
      currentCargo.value = {
        name: ''
      }
    }
    // 公司选项
    const acctCharterers = ref([])
    getEnterpriseOptionsCorpApi().then(res => {
      if (res.code === 1) {
        acctCharterers.value = res.data.filter(item => item.privSign > 0 && item.regLevel === 1 && [4, 6].includes(item.identity)).map(item => ({
          value: item.id,
          label: item.name
        }))
      }
    })
    const handleCellClassName = (row, column, rowIndex, columnIndex) => {
      if (row.rowIndex === 0 && row.columnIndex === 0) {
        return 'no-pd-cell'
      }
    }
    const selectCargo = (id) => {
      if (!id) return
      const c = cargoes.value.find(item => item.id === id)
      selectedCargoes.value[selectedTag.value] = {
        ...c
      }
      currentCargo.value = { ...c }
    }
    const clearCurrentCargo = () => {
      currentCargo.value.id = null
      selectedCargoes.value[selectedTag.value] = { name: 'new', id: 'new' }
      currentCargo.value = { name: 'new', id: '' }
    }

    const reviewEndToSubmit = (portList) => {
      showReview.value = false
      needReview.value = false

      if (route.query.orderId) {
        dialogVisible.value = true
        // submitParmas.value = _cloneDeep(p)
        return
      }

      cargoOrderAdd(submitParmas.value, submitFormData.value)
    }
    const cargoOrderAdd = (parmas, formData) => {
      if (parmas.quantityMin || parmas.quantityMax) {
        parmas.quantityMin = parmas.quantityMin || parmas.quantityMax
        parmas.quantityMax = parmas.quantityMax || parmas.quantityMin
      }
      if (parmas.capacityMin || parmas.capacityMax) {
        parmas.capacityMin = parmas.capacityMin || parmas.capacityMax
        parmas.capacityMax = parmas.capacityMax || parmas.capacityMin
      }
      if (parmas.weightMin || parmas.weightMax) {
        parmas.weightMin = parmas.weightMin || parmas.weightMax
        parmas.weightMax = parmas.weightMax || parmas.weightMin
      }
      if (parmas.llMin || parmas.llMax) {
        parmas.llMin = parmas.llMin || parmas.llMax
        parmas.llMax = parmas.llMax || parmas.llMin
      }
      // plusBbCc 同一
      parmas.plusBbCc = parmas.hireRateCc
      parmas.adcom = parmas.adcom === 'Nil' ? 0 : parmas.adcom
      cargoOrderTctAddApi(parmas).then(res => {
        if (res.code === 1) {
          cargoOrders.id = res.data.id
          SpMessage.success('add success!')
          showGlobalLoading({ message: '文件上传中...' })
          nextTick(() => {
            formData.uploadAllFile().then(res => {
              SpMessage.success('file uploaded!')
              closeGlobalLoading()
              router.push({
                name: 'allTctCargoOrders'
              })
            })
          })
        }
      })
    }

    const saveMoreRequired = (info) => {
      cargoOrders.requirements = info
    }

    const quantityUnit = computed(() => {
      let u = 'CBM'
      let units = _compact(selectedCargoes.value.map(item => item.obUnit))
      units = _uniq(units)
      if (units?.length === 1) {
        u = units[0]
      }
      if (units?.length > 1) {
        u = 'V/M'
      }
      return u
    })

    const submitComfirm = (type) => {
      dialogVisible.value = false
      if (type === 'del') {
        cargoOrderAdd({ ...submitParmas.value, deletedOrderId: route.query.orderId }, submitFormData.value)
      } else {
        cargoOrderAdd(submitParmas.value, submitFormData.value)
      }
    }
    return {
      submitDisabled,
      selectedCargoes,
      submitReview,
      selectedTag,
      delCargo,
      addNewCargo,
      getDateToFormatEn,
      formatDateSection,
      checkItem,
      handleCellClassName,
      cargoes,
      selectCargo,
      currentCargo,
      showMore,
      cargoOrders,
      acctCharterers,
      clearCurrentCargo,
      dialogVisible,
      cargoOrderAdd,
      submitParmas,
      submitFormData,
      reviewEndToSubmit,
      showReview,
      needReview,
      orderFormRef,
      submit,
      saveMoreRequired,
      needShowErr,
      quantityUnit,
      defaultOptions,
      defaultTypes,
      defaultRequirements,
      submitComfirm,
      orgrinCargoOrders,
      fullTermsContent
    }
  }
}
</script>

<style scoped lang="less">
.table-tag{
  cursor: pointer;
  width: 30px;
  height: 30px;
  position: absolute;
  z-index: 999;
  left: 0;
  top: 0;
  background: linear-gradient(-45deg, transparent 50%, #EEB336 0) top right !important;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .tag-label{
    color: #FFFFFF;
    font-size: 10px;
    text-align: center;
    margin-left: -8px;
    margin-top: 6px;
    transform: rotate(-45deg);
    &[rotate="true"]{
      transform: rotate(-45deg) translateX(-25%);
    }
  }
}
.tct-order {
  min-width: 1903px;
  .right {
    width: 410px;
    box-sizing: border-box;
    padding-top: 15px;
  }
  .left {
    width: 1441px;
  }
  .no-pd {

  }
  .open-date-select {
    padding-left: 16px;
    width: 100%;
    height: 38px;
    cursor: pointer;
  }
  .laycan-origin{
    background-color: #f5f5f5;
    height: 50px;
  }
}
</style>

<style lang="less">
.show-error-class > div:first-child {
  border: 1px solid red;
}
.show-error-div {
  border: 1px solid red;
}
.SpSelect.cus-select-12 .selected {
  font-size: 12px !important;
  text-align: left;
  text-indent: 0;
  resize: none;
  overflow: hidden;
  text-overflow: fade;
  color: #000;
  padding-top: 18px;
  padding-left: 16px;
  box-sizing: border-box;
}
.tct-order-more{
  .CargoOrderEdit2 {
    font-size: 12px !important;
    .font18 {
      font-size: 12px;
      position: relative;
      z-index: 1;
    }
    .position-input {
      top: -3px !important;
    }
    .SpInput textArea {
      font-size: 12px !important;
    }
  }
}
.cus-spTag{
  margin-right: 10px !important;
}
.cus-spTag.SpTag .sp-tag-label {
  position: relative !important;
}
.el-table .el-table__cell.no-pd {
  padding: 0 !important;
  .cell {
    padding: 0;
  }
}
.cus-card {
  .card-content{
    >.slot {
      width: 100% !important;
      padding: 0px 0 0px 0px !important;
    }
  }
}
.cus-el-select-table {
  width: 100%; height: 50px; border: none; outline: none; background-color: rgba(254, 212, 126, .2);
  .el-select__wrapper {
    text-align: center;
    color: #000000;
    line-height: 50px;
    border: none;
    outline: none;
    box-shadow: none;
    border-radius: 0;
    background: none;
    height: 50px;
    .el-select__input {
      text-align: center;
    }
    .el-select__selected-item{
      font-size: 12px;
    }
  }
  .el-select__placeholder {
    color: #000000;
  }
}
</style>
